import { Nullable } from '@ui/types/utility';
import BigNumber from 'bignumber.js';
import type { ColorToken } from 'styled-system/tokens';

export const getSemanticPropsByNumber = (
  num: Nullable<BigNumber | bigint | number>,
): {
  prefix: string;
  color: ColorToken;
} => {
  const defaultValue = {
    prefix: '',
    color: 'greyWhite.white',
  } satisfies {
    prefix: string;
    color: ColorToken;
  };

  const _num = num?.toString() ?? '0';

  if (!_num || _num === '0') {
    return defaultValue;
  }

  if (_num.startsWith('-')) {
    return {
      prefix: '-',
      color: 'price.priceDown',
    };
  }

  return {
    prefix: '+',
    color: 'price.priceUp',
  };
};
